import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateSurveyFromScratchComponent } from './create-survey-from-scratch.component';
import { FormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { ButtonModule, CheckboxModule, TagsModule, InputsModule } from '@xref/xref-lib';


@NgModule({
  declarations: [CreateSurveyFromScratchComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertModule,
    ButtonModule,
    CheckboxModule,
    TagsModule,
    InputsModule,
  ],
  providers:[QuestionnaireService]
})
export class CreateSurveyFromScratchModule { }
